import FtrLogo from './FtrLogo';
export default FtrLogo;